import { lazy } from 'react';

// ----------------------------------------------------------------------

const PermissionsPage = lazy(() => import('../pages/Permissions.page'));
const EditPermissions = lazy(() => import('../pages/EditPermissions'));
const PermissionsData = lazy(() => import('../pages/PermissionsData'));

// ----------------------------------------------------------------------

const PermissionsRoutes = [
    {
        path: '/permissions-page',
        element: <PermissionsData />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/add-permissions',
        element: <PermissionsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/edit-permission/:id',
        element: <EditPermissions />,
        layout: 'default',
        isAuthReq: true,
    },

];

export { PermissionsRoutes };
